import { GetPresignedUrlCrmo } from 'domain/usecases/surgical-order/get-presigned-url-crmo'

type PresignedUrlCrmoRepository = {
  getPresignedUrlCrmo(
    params: GetPresignedUrlCrmo.Params
  ): Promise<GetPresignedUrlCrmo.Model>
}

export class RemoteGetPresignedUrlCrmo implements GetPresignedUrlCrmo {
  constructor(
    private readonly presignedUrlRepository: PresignedUrlCrmoRepository
  ) {}

  get(params: GetPresignedUrlCrmo.Params): Promise<GetPresignedUrlCrmo.Model> {
    return this.presignedUrlRepository.getPresignedUrlCrmo(params)
  }
}
